import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;


const getConversionList = (page, pagesize, search, groupId, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/conversion-rate/', {
        headers: authHeader(), params: {
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            die_group: groupId,
            ordering: ordering
        }
    });
};

const getConversionRateArchiveList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/conversion-rate/?deleted=1', {
        headers: authHeader(), params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};

const getConversionRateById = (id) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/conversion-rate/?customer_id=${id}`, { headers: authHeader() });
};
const addConversionRate = (formData) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/conversion-rate/`,
        formData, // Payload for the request body
        { headers: authHeader() }
    );
};
const updateConversionRate = (formPayload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/conversion-rate/bulk-update/`, // Include the die group's ID in the URL
        formPayload, // Payload for the request body
        { headers: authHeader() }
    );
};
const deleteConversionRate = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/conversion-rate/${id}/archive/`, {},
        { headers: authHeader() } // Authentication header
    );
};
const unArchiveConversionRate = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/conversion-rate/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const conversionRateService = {
    getConversionList,
    getConversionRateArchiveList,
    getConversionRateById,
    addConversionRate,
    updateConversionRate,
    deleteConversionRate,
    unArchiveConversionRate
};

export default conversionRateService;
